/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_DateInputs */

const de__field_date = /** @type {(inputs: _Field_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt am`)
};

/**

* @param {_Field_DateInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_date = /** @type {((inputs?: _Field_DateInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_DateInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_date(inputs)
});